import { isMobile } from '@/utils/features';
import { getRandomNumber } from '@/utils/random';
import setupParallax from '@/utils/setupParallax';

export default function(dom, opts) {
	let options = {
		baseClass: 'parallax',
		fullRotation: 180,
		fullMovement: -100,
		baseMovement: 25,
		...opts
	};

	const shapes = Array.from(dom.querySelectorAll(`.${options.baseClass}__shape`));
	const items = Array.from(dom.querySelectorAll(`.${options.baseClass}__text, .${options.baseClass}__image`));

	const randomShapeFactors = shapes.map(shape => getRandomNumber(0.75, 1));
	const randomItemFactors = items.map(item => getRandomNumber(0.5, 1));

	const updateParallax = ({factor, factorReversed}) => {
		for (let i in shapes) {
			shapes[i].style.transform = `rotateZ(${factor * options.fullRotation * randomShapeFactors[i]}deg)`;
		}

		if (isMobile()) {
			for (let ii in items) {
				items[ii].style.transform = `translate3d(0, 0, 0)`;
			}
		}
		else {
			for (let ii in items) {
				items[ii].style.transform = `translate3d(0, ${options.baseMovement + (factor * options.fullMovement * randomItemFactors[ii])}%, 0)`;
			}
		}
	};

	setupParallax(dom, updateParallax);
}
